import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { ref: "download" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "tooltiptext"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_PartialCheckbox = _resolveComponent("PartialCheckbox")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_BaseFile = _resolveComponent("BaseFile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.targetFile)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          block: "",
          class: "md-6",
          onClick: _ctx.exportTargetFileMetadata
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Export Target File Metadata", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("a", _hoisted_1, null, 512),
    _createVNode(_component_PartialCheckbox, {
      modelValue: _ctx.partitionInclude,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.partitionInclude) = $event)),
      labels: _ctx.updatePartitions
    }, null, 8, ["modelValue", "labels"]),
    (_ctx.echartsData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_PieChart, {
            echartsData: _ctx.echartsData,
            onClick: _ctx.piechartClick
          }, null, 8, ["echartsData", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateChart('blocks')))
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Analyse Installed Blocks ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateChart('payload')))
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" Analyse Payload Composition ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateChart('partitions')))
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" Analyse Partition Payload Composition ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4",
          class: "tooltip"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              disabled: 
          _ctx.manifest.nonAB || !_ctx.manifest.dynamicPartitionMetadata || !_ctx.manifest.dynamicPartitionMetadata.vabcEnabled
        ,
              title: "Only available for VABC update",
              block: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateChart('COWmerge')))
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Analyse COW Merge Operations ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (_ctx.manifest.nonAB)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " This function is only supported in A/B OTA "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              block: "",
              disabled: !_ctx.targetFile,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateChart('filenames')))
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" Analyse Filenames ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              block: "",
              disabled: !_ctx.targetFile,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateChart('extensions')))
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Analyse File Extensions ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            (!_ctx.demo)
              ? (_openBlock(), _createBlock(_component_BaseFile, {
                  key: 0,
                  label: "Drag and drop or Select The target Android build",
                  onFileSelect: _ctx.selectBuild
                }, null, 8, ["onFileSelect"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}